import * as types from './types';

const initialState = {
  dashboard: {}
};

export default function clientsReducer(state = initialState, action) {
  switch (action.type) {
    case types.GET_METADATA_DOMAIN_SUCCESS: {
      return {
        ...state,
        dashboardDomains: action.payload
      };
    }
    case types.GET_METADATA_DOMAIN_FAILURE:
      return { ...state, error: action.payload };

    case types.GET_METADATA_YEAR_SUCCESS: {
      return {
        ...state,
        dashboardYears: action.payload
      };
    }
    case types.GET_METADATAYEAR_FAILURE:
      return { ...state, error: action.payload };

    case types.GET_METADATA_DASHBOARD_COUNT_SUCESS: {
      return {
        ...state,
        dashboardCounts: action.payload
      };
    }
    case types.GET_METADATA_DASHBOARD_COUNT_FAILURE:
      return { ...state, error: action.payload };

    case types.GET_METADATA_FORMS_SUCESS: {
      return {
        ...state,
        dashboardForms: action.payload
      };
    }
    case types.GET_METADATA_FORMS_FAILURE:
      return { ...state, error: action.payload };

    case types.GET_TOTAL_DATA_COLLECTION_SUCESS: {
      return {
        ...state,
        dashboardTotalCollections: action.payload
      };
    }
    case types.GET_TOTAL_DATA_COLLECTION_FAILURE:
      return { ...state, error: action.payload };

    case types.GET_TOTAL_UPLOAD_SUCESS: {
      return {
        ...state,
        dashboardTotalUploads: action.payload
      };
    }
    case types.GET_TOTAL_UPLOAD_FAILURE:
      return { ...state, error: action.payload };

    case types.GET_TOTAL_CHANGES_SUCESS: {
      return {
        ...state,
        dashboardTotalManualUplaods: action.payload
      };
    }
    case types.GET_TOTAL_CHANGES_FAILURE:
      return { ...state, error: action.payload };

    case types.EXPORT_METADATA_SUCESS: {
      return {
        ...state,
        dashboardExportMetadata: action.payload
      };
    }
    case types.EXPORT_METADATA_FAILURE:
      return { ...state, error: action.payload };

    case types.GET_AR_CURRENT_YEAR_DATES_SUCCESS: {
      return {
        ...state,
        dashboardARCurrentYearDates: action.payload
      };
    }
    case types.GET_AR_CURRENT_YEAR_DATES_FAILURE:
      return { ...state, error: action.payload };

    default:
      return state;
  }
}
